import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useIsomorphicLayoutEffect } from '../hooks';
const DEFAULT_ID = 'waffles-portal-root';
function Portal({ children, id = DEFAULT_ID }) {
    const portalRef = useRef(null);
    const [isMounted, setIsMounted] = useState(false);
    const [, forceUpdate] = useState(Object.create(null));
    useIsomorphicLayoutEffect(() => {
        const rootNode = document.getElementById(id);
        if (rootNode != null) {
            portalRef.current = rootNode;
        }
        else {
            portalRef.current = document.createElement('div');
            portalRef.current.id = id;
        }
        if (!document.body.contains(portalRef.current)) {
            document.body.appendChild(portalRef.current);
            forceUpdate(Object.create(null));
        }
        setIsMounted(true);
    }, [id]);
    return isMounted && portalRef.current != null
        ? createPortal(children, portalRef.current)
        : null;
}
export default Portal;
